import { Body14Regular } from "@/components/typography/Body14Regular";
import { UserDto } from "@/types/dto/user-dto";
import { Table } from "flowbite-react";
import { CustomCell } from "../CustomCell";

interface Props {
  user: UserDto;
}

export const AdminDetailTable: React.FC<Props> = ({ user }) => {
  const headCellStyle = "font-medium text-gray-900 bg-gray-100";

  return (
    <div className="overflow-x-auto rounded-lg border">
      <Table>
        <Table.Body>
          <Table.Row className="border-b border-gray-200">
            <Table.Cell className={`${headCellStyle} w-[112px] p-0 h-[52px]`}>
              <CustomCell>
                <Body14Regular className="text-semantic-text-secondary">
                  관리자명
                </Body14Regular>
              </CustomCell>
            </Table.Cell>
            <Table.Cell className="w-[680px] bg-primary-white">
              <CustomCell>
                <Body14Regular className="text-semantic-text-body">
                  {user.name}
                </Body14Regular>
              </CustomCell>
            </Table.Cell>
            <Table.Cell
              className={`${headCellStyle} w-[112px] p-0 h-[52px] border-l`}
            >
              <CustomCell>
                <Body14Regular className="text-semantic-text-secondary">
                  연락처
                </Body14Regular>
              </CustomCell>
            </Table.Cell>
            <Table.Cell className="px-[6px] w-[680px] h-[52px] bg-primary-white">
              <Body14Regular className="text-semantic-text-body">
                {user.phone || ""}
              </Body14Regular>
            </Table.Cell>
          </Table.Row>
          <Table.Row className="border-b border-gray-200">
            <Table.Cell className={`${headCellStyle} w-[112px] p-0 h-[52px]`}>
              <CustomCell>
                <Body14Regular className="text-semantic-text-secondary">
                  이메일
                </Body14Regular>
              </CustomCell>
            </Table.Cell>
            <Table.Cell className="w-[680px] bg-primary-white">
              <CustomCell>
                <Body14Regular className="text-semantic-text-body">
                  {user.email}
                </Body14Regular>
              </CustomCell>
            </Table.Cell>
            <Table.Cell
              className={`${headCellStyle} w-[112px] p-0 h-[52px] border-l`}
            >
              <CustomCell>
                <Body14Regular className="text-semantic-text-secondary">
                  부서
                </Body14Regular>
              </CustomCell>
            </Table.Cell>
            <Table.Cell className="w-[680px] bg-primary-white">
              <CustomCell>
                <Body14Regular className="text-semantic-text-body">
                  {user.department?.name || ""}
                </Body14Regular>
              </CustomCell>
            </Table.Cell>
          </Table.Row>
        </Table.Body>
      </Table>
    </div>
  );
};
